import { IMModelingPrompt, IMSection } from '../../types'
import { createNodeList } from '../../../nodeCreationHelpers'
import { sectionChildren } from './section'
import { ISimplifiedNode } from '../../../../components/ingestion/IngestedTree'
import { createDocumentNode } from '../createNodeWrappers'

export function parseUnitSections({
  sections,
  modelingPrompts,
  midAssessments,
  ...familySupportStuff
}: {
  unitOrdinalTitle: string
  unitFamilySupport?: string
  sections: IMSection[]
  modelingPrompts: IMModelingPrompt[]
  midAssessments: Record<string, ISimplifiedNode[]>
}) {
  const parsedSections = sections.map((section) => {
    return createDocumentNode(
      `${section.ordinal_title}: ${section.title}`,
      sectionChildren(
        section,
        modelingPrompts,
        familySupportStuff,
        midAssessments,
      ),
    )
  })
  return createNodeList({ title: 'Sections' }, parsedSections)
}
